import { Controller } from '@hotwired/stimulus'
import { emit } from '../lib/events'

export default class extends Controller {
  static targets = ['image']

  connect = () => {
    this.simulateLazyLoad()
  }

  // TODO: not used at the moment, remove
  loadAllImages = () => {
    this.imageTargets.forEach((img) => {
      img.src = img.dataset.src
    })
  }

  simulateLazyLoad = () => {
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const img = entry.target

          img.src = img.dataset.src
          observer.unobserve(img)
          emit('generateMasonry', { bubbles: true })
        }
      })
    }, { root: null, threshold: 0, rootMargin: '200px' })

    this.imageTargets.forEach(img => observer.observe(img))
  }

  // TODO: not used at the moment, might be handy at some point
  get isSafari() {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
  }
}
